module.exports = __webpack_public_path__ + "img/chinese.ccbca8cf.png";